<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 关闭 </a-button>
      <a-button key="submit" v-if="!isDisAbleEdit" type="primary" :loading="loading" @click="handleOk"> 确认 </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" class="my-ant-form">
        <a-descriptions title="拜访信息" bordered layout="horizontal" :column="2" size="small">
          <a-descriptions-item>
            <span slot="label">客户类型<span class="is-need-input">*</span></span>
            <a-form-item>
              <j-dict-select-tag
                dictCode="visitor_hd_doctype"
                :triggerChange="true"
                @change="handleDoctypeChange"
                v-decorator="['doctype', validatorRules.doctype]"
                placeholder="请输入客户类型"
                :disabled="isDisAbleEdit"
              ></j-dict-select-tag>
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">拜访时间<span class="is-need-input">*</span></span>
            <a-form-item>
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择拜访时间"
                v-decorator="['docdate', validatorRules.docdate]"
                :trigger-change="true"
                style="width: 100%"
                :disabled="isDisAbleEdit"
              />
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">拜访原因<span class="is-need-input">*</span></span>
            <a-form-item>
              <a-input
                v-decorator="['whystr', validatorRules.whystr]"
                placeholder="请输入拜访原因"
                :disabled="isDisAbleEdit"
              ></a-input>
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">接待位置<span class="is-need-input">*</span></span>
            <a-form-item>
              <j-multi-select-tag
                dictCode="visitor_hd_jdplace"
                :triggerChange="true"
                v-decorator="['place', validatorRules.place]"
                placeholder="请输入接待位置"
                :disabled="isDisAbleEdit"
              >
              </j-multi-select-tag>
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">拜访天数<span class="is-need-input">*</span></span>
            <a-form-item>
              <a-input
                v-decorator="['docDay', validatorRules.docDay]"
                type="number"
                style="width: 219px"
                placeholder="请输入拜访天数"
                :disabled="isDisAbleEdit"
              ></a-input>
            </a-form-item>
          </a-descriptions-item>
          <!-- <a-descriptions-item label="二维码"
                               v-if="isDisAbleEdit">
            <a-form-item>
              <div id="qrcode"
                   class="qrcode-img"></div>
            </a-form-item>
          </a-descriptions-item> -->
        </a-descriptions>
        <div class="ant-descriptions-title">访客信息</div>
        <a-table :columns="columns" rowKey="id" :data-source="FormDataList.frontVisitorsList">
          <a slot-scope="bkname">{{ bkname }}</a>
          <a slot-scope="bktel">{{ bktel }}</a>
          <span slot="action" slot-scope="text, record, index">
            <a @click="modify(record, index)">
              {{ DetailModification }}
            </a>
            <a @click.stop="delects(index)" v-if="delectsshow"> 删除 </a>
          </span>
        </a-table>
        <!-- <a-list item-layout="horizontal"
                :data-source="FormDataList.frontVisitorsList">
          <a-list-item slot="renderItem"
                       slot-scope="item, index">
            <a slot="actions"
               @click="modify(index)">{{DetailModification}}</a>
            <a-list-item-meta>
              <a slot="title">{{ item.bkname }}</a>

            </a-list-item-meta>
          </a-list-item>
        </a-list> -->
        <div class="addbtn" v-if="showadd">
          <a-button type="primary" @click="showModal"> 新增访客信息 </a-button>
        </div>

        <a-modal
          :title="modelTitle"
          :visible="visibleup"
          :width="width"
          :confirm-loading="confirmLoading"
          @ok="handleOkup"
          @cancel="handleCancelup"
        >
          <div style="margin-bottom: 10px" v-if="visitorNotes && visitorNotesStatus === '0'">
            <span slot="label">访客公告：</span>
            <span class="is-need-input">{{ visitorNotes }}</span>
          </div>
          <a-descriptions title="访客信息" bordered layout="horizontal" :column="2" size="small">
            <a-descriptions-item>
              <span slot="label">姓名<span class="is-need-input">*</span></span>
              <a-form-item label="">
                <a-input
                  v-decorator="['bkname', validatorRules.bkname]"
                  placeholder="请输入访客姓名"
                  :disabled="isDisAbleEdit"
                ></a-input>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">电话<span v-if="!isForeignerFlag" class="is-need-input">*</span></span>
              <a-form-item label="" >
                <a-input
                  v-decorator="['bktel', {
                    rules: [{ required: !isForeignerFlag, message: '请输入访客电话' }],
                  }]"
                  placeholder="请输入访客电话"
                  :disabled="isDisAbleEdit"
                ></a-input>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">{{ lableOfBKCom }}<span class="is-need-input">*</span></span>
              <a-form-item label="">
                <a-input
                  v-decorator="['bkcom', validatorRules.bkcom]"
                  placeholder="请输入访客单位名"
                  :disabled="isDisAbleEdit"
                ></a-input>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item label="身份证">
              <a-form-item label="">
                <a-input
                  v-decorator="['idNumber', validatorRules.idNumber]"
                  placeholder="请输入访客身份证"
                  :disabled="isDisAbleEdit"
                ></a-input>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item label="车牌号">
              <a-form-item label="">
                <a-input
                  v-decorator="['bkbill', validatorRules.bkbill]"
                  placeholder="请输入访客车牌号"
                  :disabled="isDisAbleEdit"
                ></a-input>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">车辆类型</span>
              <a-form-item label="">
                <j-dict-select-tag
                  dictCode="visitor_hd_vehicle_type"
                  :triggerChange="true"
                  v-decorator="['vehicleType', validatorRules.vehicleType]"
                  placeholder="请输入访客车牌号"
                  :disabled="isDisAbleEdit"
                  :selectClear="true"
                ></j-dict-select-tag>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">是否外国人<span class="is-need-input">*</span></span>
              <a-form-item label="">
                <j-dict-select-tag
                  dictCode="status_yes_no"
                  :triggerChange="true"
                  v-decorator="['whetherForeigner', validatorRules.whetherForeigner]"
                  @change="handleWhetherForeignerChange"
                  placeholder="请选择是否外国人"
                  :disabled="isDisAbleEdit"
                  :selectClear="true"
                ></j-dict-select-tag>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">邮箱<span v-if="isForeignerFlag" class="is-need-input">*</span></span>
              <a-form-item label="">
                <a-input
                  v-decorator="['email', {
                    rules: [{ required: isForeignerFlag, message: '请输入邮箱', trigger: 'change' }],
                  }]"
                  placeholder="请输入邮箱"
                  :disabled="isDisAbleEdit"
                ></a-input>
              </a-form-item>
            </a-descriptions-item>
          </a-descriptions>
          <!-- <div style="margin: 10px 0" v-if="visitorHealthNotes && visitorHealthNotesStatus === '0'">
            <span slot="label">疫情防控公告：</span>
            <span class="is-need-input">{{visitorHealthNotes}}</span>
          </div>
          <a-descriptions v-if="isShowHealthCode"
                          class="descriptiom-defind"
                          title="疫情防控"
                          bordered
                          layout="horizontal"
                          :column="1"
                          size="small">
            <a-descriptions-item>
              <span slot="label">健康码<span class="is-need-input">*</span></span>
              <a-form-item label="">
                <j-dict-select-tag class="mini-width"
                                   dictCode="visitor_hd_health_code"
                                   :triggerChange="true"
                                   v-decorator="[ 'healthCode', validatorRules.healthCode]"
                                   placeholder="请选择健康码"
                                   :disabled="isDisAbleEdit"
                                   :selectClear="true"></j-dict-select-tag>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">健康码截图<span class="is-need-input">*</span></span>
              <a-form-item label="">
                <j-upload :multiple="false"
                          ref="healthCodeUrlListRef"
                          v-decorator="[ 'healthCodeUrlList', validatorRules.healthCodeUrlList]"
                          placeholder="请上传健康码截图"
                          :number="1"
                          :trigger-change="true"
                          :beforeUpload="beforeUpload"
                          :uploadAction="uploadActionHealth"></j-upload>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">行程码截图</span>
              <a-form-item label="">
                <j-upload :is-multiple="false"
                          ref="tripCodeUrlListRef"
                          v-decorator="[ 'tripCodeUrlList', validatorRules.tripCodeUrlList]"
                          placeholder="请上传行程码截图"
                          :uploadAction="uploadActionTrip"
                          @change="handleChange"
                          @delete="handleDeleteTrip"
                          :trigger-change="true"></j-upload>
              </a-form-item>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">核酸报告<span class="is-need-input" v-if="reportState">*</span></span>
              <a-form-item label="">
                <j-upload :is-multiple="false"
                          ref="healthReportListRef"
                          v-decorator="[ 'healthReportList', validatorRules.healthReportList]"
                          placeholder="请上传核酸报告截图"
                          :uploadAction="uploadAction"
                          @change="handleChangeReport"
                          @delete="handleDeleteReport"
                          :trigger-change="true"></j-upload>
                          <span v-if="showWarnMsg&&reportState" class="is-need-input" style="position: relative;top: -5px;">请上传核酸报告</span>
              </a-form-item>
            </a-descriptions-item>
          </a-descriptions> -->
        </a-modal>
        <a-descriptions title="接待人信息" bordered layout="horizontal" :column="2" size="small">
          <a-descriptions-item>
            <span slot="label">接待人<span class="is-need-input">*</span></span>
            <a-form-item>
              <a-input
                @click="handleJDNameClick"
                v-decorator="['jdname', validatorRules.jdname]"
                placeholder="请选择接待人"
                :read-only="true"
                :disabled="isDisAbleEdit"
              ></a-input>
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">电话</span>
            <a-form-item>
              <a-input
                v-decorator="['jdtel', validatorRules.jdtel]"
                placeholder="选择接待人后自动填充"
                :disabled="isDisAbleEdit"
              ></a-input>
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">现岗位</span>
            <a-form-item>
              <a-input
                v-decorator="['bfpos', validatorRules.bfpos]"
                placeholder="选择接待人后自动填充"
                :disabled="isDisAbleEdit"
              ></a-input>
            </a-form-item>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">接待人工号</span>
            <a-form-item>
              <a-input
                v-decorator="['postcode', validatorRules.postcode]"
                placeholder="选择接待人后自动填充"
                :disabled="isDisAbleEdit"
              ></a-input>
            </a-form-item>
          </a-descriptions-item>
        </a-descriptions>
      </a-form>
      <select-user-modal ref="selectUserModal" @selectedOne="handleSelected" :onlySelectOne="true"></select-user-modal>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import { findByDepartByUsername, getVisitorDetailById, getVisitorConfigById } from '@/api/api'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDate from '@/components/jeecg/JDate'
import JUpload from '../components/JUpload'
import QRCode from 'qrcodejs2'
import JDictSelectTag from '../../../components/dict/JDictSelectTag.vue'
import SelectUserModal from '@/components/common/SelectUserModal'
import JMultiSelectTag from '../../../components/dict/JMultiSelectTag.vue'
import moment from 'moment'
const uidGenerator = () => {
  return '-' + parseInt(Math.random() * 10000 + 1, 10)
}
import { mapState } from 'vuex'
export default {
  name: 'VisitorModal',
  components: {
    JDate,
    JUpload,
    JDictSelectTag,
    SelectUserModal,
    JMultiSelectTag,
  },
  data() {
    return {
      DetailModification: '修改',
      delectsshow: true,
      showadd: true,
      visibleup: false,
      loading: false,
      columns: [
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'bkname',
        },
        {
          title: '电话',
          align: 'center',
          dataIndex: 'bktel',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      form: this.$form.createForm(this),
      isForeignerFlag: false,  /// 是否是外国人标志， 是外国人则邮箱必填，不是外国人则手机号必填
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        docdate: {
          rules: [{ required: true, message: '请选择拜访日期' }],
        },
        bkname: {
          rules: [{ required: true, message: '请选输入客姓名' }],
        },
        bktel: {
          rules: [{ required: !this.isForeignerFlag, message: '请输入访客电话' }],
        },
        jdname: {
          rules: [{ required: true, message: '请输入接待人姓名' }],
        },
        jdtel: {
          rules: [{ required: true, message: '请输入接待人电话' }],
        },
        postcode: {
          rules: [{ required: true, message: '请输入接待人工号' }],
        },
        place: {
          rules: [{ required: true, message: '请选择接待地点' }],
        },
        whystr: {
          rules: [{ required: true, message: '请输入拜访原因' }],
        },
        docDay: {
          rules: [{ required: true, message: '拜访天数最少一天，最多三天' }],
        },
        doctype: {
          rules: [{ required: true, message: '请选择客户类型' }],
        },
        vehicleType: {
          rules: [{ required: false, message: '请选择车辆类型' }],
        },
        healthCode: {
          rules: [{ required: true, message: '请选择健康码类型' }],
        },
        // tripCodeUrlList: {
        //   rules: [
        //     { required: true, message: '请上传行程码' }
        //   ]
        // },
        healthCodeUrlList: {
          rules: [{ required: true, message: '请上传健康码' }],
        },
        healthReportList: {
          // rules: [
          //   { required: true, message: '请上传核酸报告' }
          // ]
        },
        idNumber: {
          rules: [],
        },
        bkcom: {
          rules: [{ required: true, message: '请输入拜访人单位名称' }],
        },
        bkbill: {
          rules: [],
        },
        bfpos: {
          rules: [],
        },
        whetherForeigner:{
          rules: [{ required: true, message: '请选择是否外国人', trigger: 'change' }],
        },
        email: {
          rules: [{ required: this.isForeignerFlag, message: '请选择是否外国人', trigger: 'change' }],
        },
      },
      formlost: [],
      url: {
        add: '/visitor/base/visitor/addVisitorsList',
        edit: '',
      },
      qrcode: null,
      lableOfBKCom: '单位',
      uploadAction: process.env.VUE_APP_domianURL + '/visitor/base/open/openApi/uploadFile',
      uploadActionHealth:
        process.env.VUE_APP_domianURL + '/visitor/base/open/openApi/imageRecognition?type=' + 'healthCode',
      uploadActionTrip:
        process.env.VUE_APP_domianURL + '/visitor/base/open/openApi/imageRecognition?type=' + 'tripCode',
      showHealthCode: false,
      oldValue: null,
      FormDataList: {
        frontVisitorsList: [],
      },
      visitorHealthNotes: null,
      visitorNotes: null,
      visitorHealthNotesStatus: null,
      visitorNotesStatus: null,
      reportState: false,
      showWarnMsg: false,
      modelTitle: '',
      curIndex: '',
    }
  },
  created() {
    getVisitorConfigById({ id: '1499574083859345410' }).then((res) => {
      //访客公告
      if (res.code === 200) {
        this.visitorNotes = res.result.notes
        this.visitorNotesStatus = res.result.switchStatus
      }
    })
    getVisitorConfigById({ id: '1499574810711015426' }).then((res) => {
      //疫情防控公告
      if (res.code === 200) {
        this.visitorHealthNotes = res.result.notes
        this.visitorHealthNotesStatus = res.result.switchStatus
      }
    })
  },
  methods: {
    handleWhetherForeignerChange(value) {
      this.$set(this, 'isForeignerFlag', value === '1');
      // console.log(value, '??????????????????????????', this.isForeignerFlag)
      this.$nextTick(() => {
        this.form.validateFields();
      })
    },
    loaded() {
      this.$nextTick(() => {
        //age是对应表的字段名
        this.form.setFieldsValue({ docDay: '1' })
      })
    },
    add() {
      this.DetailModification = '修改'
      this.showadd = true
      this.FormDataList.frontVisitorsList = []
      this.form.setFieldsValue({
        healthCodeUrlList: [],
        tripCodeUrlList: [],
        healthReportList: [],
      })
      this.loaded()
      this.edit(this.oldValue)
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      if (this.oldValue) {
        this.$nextTick(() => {
          this.DetailModification = '详情'
          this.delectsshow = false
          this.form.setFieldsValue(
            pick(
              this.oldValue,
              'docdate',
              'bkname',
              'bktel',
              'jdname',
              'jdtel',
              'place',
              'whystr',
              'docDay',
              'doctype',
              'bkcom',
              'bfpos',
              'postcode',
              'vehicleType',
              'healthCode'
            )
          )
        })
      } else
        this.$nextTick(() => {
          this.delectsshow = false
          this.form.setFieldsValue(
            pick(
              this.model,
              'docdate',
              'bkname',
              'bktel',
              'jdname',
              'jdtel',
              'place',
              'whystr',
              'docDay',
              'doctype',
              'bkcom',
              'bfpos',
              'postcode',
              'vehicleType',
              'healthCode'
            )
          )
          if (this.model.id) {
            // if (this.qrcode) {
            //   this.qrcode.makeCode(this.model.id);
            // } else {
            //   this.qrcode = new QRCode("qrcode", {
            //     text: this.model.id,
            //     width: 200,
            //     height: 200,
            //     colorDark: "#000000",
            //     colorLight: "#ffffff",
            //     correctLevel: QRCode.CorrectLevel.H
            //   });
            // }
            //获取详情
            getVisitorDetailById({ id: this.model.id })
              .then((res) => {
                if (res.code === 200) {
                  this.DetailModification = '详情'
                  this.FormDataList.frontVisitorsList = []
                  res.result.batchVisitorsList.map((vl) => {
                    this.FormDataList.frontVisitorsList.push(vl)
                  })
                  console.log('详情', this.FormDataList)
                  this.showadd = false
                  this.form.setFieldsValue({
                    healthCodeUrlList: res.result.healthCodeUrlList,
                    tripCodeUrlList: res.result.tripCodeUrlList,
                    healthReportListRef: res.result.healthReportList,
                  })
                  if (res.result.healthCodeUrlList) {
                    this.$refs.healthCodeUrlListRef.initFileListArr(res.result.healthCodeUrlList)
                  }
                  if (res.result.tripCodeUrlList) {
                    this.$refs.tripCodeUrlListRef.initFileListArr(res.result.tripCodeUrlList)
                  }
                  if (res.result.healthReportList) {
                    this.$refs.healthReportListRef.initFileListArr(res.result.healthReportList)
                  }
                } else {
                  this.$message({
                    type: 'error',
                    message: '获取详情失败：' + res.message,
                  })
                }
              })
              .catch((error) => {
                this.$message({
                  type: 'error',
                  message: '获取详情失败：' + error.message,
                })
              })
          } else {
          }
          this.handleDoctypeChange(this.model.doctype)
        })
    },
    close() {
      this.form.resetFields()
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        values.places = values.place.split(",");
        if (values.docDay < 1 || values.docDay > 3) {
          this.$message.warning('拜访天数最少一天，最多三天')
          return false
        } else {
          if (!Number.isInteger(Number(values.docDay))) {
            this.$message.warning('拜访天数必须为整数')
            return false
          }
          // if(Number(new Date(values.docdate).getTime()) < Number(new Date(new Date().toLocaleDateString()).getTime())){
          //   this.$message.warning('只能预约今天或明天')
          //   return false
          // }
          // if(Number(new Date(values.docdate).getTime()) > Number(new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000*2-1))){
          //   this.$message.warning('只能预约今天或明天')
          //   return false
          // }
          if (this.FormDataList.frontVisitorsList.length < 1) {
            this.$message.warning('请先添加访客信息')
          } else {
            if (!err) {
              this.confirmLoading = true
              let httpurl = ''
              let method = ''
              let formData = Object.assign(this.model, values, this.FormDataList)
              console.log('val2', formData)
              if (!this.model.id) {
                httpurl += this.url.add
                method = 'post'
                formData.source = 'PC'
              } else {
                httpurl += this.url.edit
                method = 'post'
              }
              this.oldValue = values
              console.log('表单提交数据', formData)
              httpAction(httpurl, formData, method)
                .then((res) => {
                  if (res.success) {
                    this.$message.success(res.message)
                    this.$emit('ok')
                  } else {
                    this.$message.warning(res.message)
                  }
                })
                .finally(() => {
                  this.confirmLoading = false
                  this.close()
                })
            }
          }
        }
      })
    },
    handleOkup() {
      this.form.validateFields(['bkname', 'bktel', 'bkcom', 'vehicleType', 'idNumber', 'bkbill', 'whetherForeigner', 'email'], (err, values) => {
        console.log(this.$refs.healthReportListRef)
        // if((!this.$refs.healthReportListRef.value || this.$refs.healthReportListRef.value.length===0) && this.reportState) {
        //   this.showWarnMsg = true
        //   return false
        // }else{
        //   this.showWarnMsg = false
        // }
        if (!err) {
          if (this.modelTitle === '新增') {
            this.FormDataList.frontVisitorsList.push(values)
            this.visibleup = false
          } else {
            this.FormDataList.frontVisitorsList.splice(this.curIndex, 1, values)
            this.visibleup = false
            // this.FormDataList.frontVisitorsList.push(values)
          }
          console.log('values22', this.FormDataList)
        }
      })
    },
    modify(record, index) {
      console.log('修改data', record, 'index:', index)
      const that = this
      // record.healthCodeUrlList.map(item => {
      //   item.url = item.fileUrl;
      //   return item
      // })
      that.visibleup = true
      this.modelTitle = '编辑'
      that.curIndex = index
      that.$nextTick(() => {
        that.form.setFieldsValue(
          pick(
            record,
            'whetherForeigner',
            'email',
            'docdate',
            'bkname',
            'bktel',
            'idNumber',
            'jdname',
            'jdtel',
            'place',
            'whystr',
            'docDay',
            'doctype',
            'bkcom',
            'bkbill',
            'bfpos',
            'postcode',
            'vehicleType',
            'healthCode',
            'healthCodeUrlList',
            'tripCodeUrlList',
            'healthReportList'
          )
        )
      })
    },

    delects(index) {
      const that = this
      this.$antdConfirm({
        title: '是否删除人员?',
        content: '',
        okText: '是',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          that.FormDataList.frontVisitorsList.splice(index)
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    handleCancel() {
      this.close()
    },
    handleCancelup() {
      this.visibleup = false
    },
    handleJDNameClick() {
      if (!this.isDisAbleEdit) {
        this.$refs.selectUserModal.visible = true
      }
    },
    handleSelected(rows) {
      this.form.setFieldsValue({
        jdname: rows[0].realname,
        postcode: rows[0].username,
        jdtel: rows[0].phone,
      })
      //获取现岗位接口
      findByDepartByUsername({
        username: rows[0].username,
      })
        .then((res) => {
          if (res.code != 200) {
            this.$message.error(res.message)
          } else {
            this.form.setFieldsValue({
              bfpos: res.result,
            })
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    handleDoctypeChange(newValue) {
      if (newValue === '面试对象') {
        this.lableOfBKCom = '应聘岗位'
        return
      }
      this.lableOfBKCom = '单位'
    },
    handleChange(info) {
      console.log('handleChange', info)
      if (info.length > 0 && info[0].message === 'true') {
        console.log('info.message', info[0].message)
        this.reportState = true
      } else {
        this.reportState = false
      }
    },
    handleChangeReport(info) {
      console.log('handleChangeReport', info)
      if (info.length > 0 && info[0].message === '操作成功！') {
        this.showWarnMsg = false
      }
    },
    handleDeleteReport(info) {
      console.log('handleDeleteReport', info)
    },
    handleDeleteTrip(info) {
      console.log('handleDeleteTrip', info)
      this.reportState = false
    },
    beforeUpload(file) {
      // console.log('图片', file)
      const param = new FormData()
      param.append('file', file)
      param.append('type', 'healthCode')
      // console.log('FormData', file)
      return param
    },
    callback(key) {
      console.log(key)
    },
    showModal() {
      console.log('这才是新增的')
      const that = this
      this.visibleup = true
      this.delectsshow = true
      this.reportState = false
      this.showWarnMsg = false
      this.modelTitle = '新增'
      this.form.resetFields([
        'whetherForeigner',
        'email',
        'bkname',
        'bktel',
        'idNumber',
        'bkbill',
        'bkcom',
        'vehicleType',
        'healthCode',
        'healthCodeUrlList',
        'tripCodeUrlList',
        'healthReportList',
      ])
      this.$nextTick(() => {
        that.form.setFieldsValue({
          whetherForeigner: '0',
          healthCodeUrlList: [],
          tripCodeUrlList: [],
          healthReportList: [],
        })
      })
    },
  },
  computed: {
    isDisAbleEdit() {
      return this.model.id ? true : false
    },
    isShowHealthCode() {
      console.log(this.visitorConfig)
      if (this.model.id) {
        return this.model.healthCode ? true : false
      } else {
        return this.visitorConfig.healthSwitch
      }
    },
    ...mapState({
      visitorConfig: (state) => state.app.visitorConfig,
    }),
  },
}
</script>
<style lang="less" scoped>
.my-ant-form {
  .is-need-input {
    color: red;
    margin-left: 5px;
  }
  /deep/.ant-descriptions-title {
    margin-top: 20px;
    margin-bottom: 10px !important;
  }
  .descriptiom-defind {
    /deep/.ant-descriptions-item-label {
      width: 111px;
    }
  }
  .ant-form-item {
    margin-bottom: 0px;
    .ant-input-number-disabled {
      /deep/.ant-input-number-input {
        background: #ffffff;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .ant-input-disabled {
      background: #ffffff;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .addbtn {
    float: right;
  }
}
.ant-select {
  width: 100%;
}
.is-need-input {
  color: red;
  margin-left: 5px;
}
.ant-form-item {
  margin-bottom: 0px;
}
</style>
